import styled from 'styled-components'

export const Field = styled.div`
  width: 16rem;

  & > label {
    height: 2rem;
  }

  & > input, select {
    height: 2.5rem;
  }
`

export const Form = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 0.4rem;
`

export const Submit = styled.input`
  margin-top: 2rem;
  width: 16rem;
  height: 2.5rem;
`

export const Button = styled.button`
  outline-color: #002d63;
  margin-top: 2rem;
  width: 16rem;
  height: 2.5rem;
  border: 1px solid #c7c9c7;
  border-radius: 4px;
  color: #ffffff;
  background-color: ${({ disabled }) => (disabled ? '#bbbbbb' : '#2e79e8')};
  font-weight: bold;
`
